<template>
    <main id="machine-sheet-summary">
        <div class="columns">
            <div class="column is-5">
              <sheet-block-overview-picture :picture-datas="mainImage" :hide-download="false" :doc-type="'machines'" :show-a-r-experience="isFromARMachines" :family="familyForAR" :experience-data="experienceData" />
            </div>
            <div class="column is-7 titled-paragraphs-container">
                <titled-paragraph-list v-if="paragraphs"
                    :paragraphs="paragraphs"
                />
            </div>
        </div>
        <div class="wrapper">
            <div class="columns">
                <div class="column is-5">
                   <sheet-block-key-features />
                </div>
                <div class="column is-7">
                    <!--<tag-list
                        class="activity-sectors-tags"
                        :title="$t('we_recommend_these_sectors')"
                        :tags="recommendedBusinessesTags"
                        v-if="recommendedBusinessesTags.length > 0"
                    />-->
                    <tag-list
                        class="jobs-tags"
                        :title="$t('we_recommend_these_businesses')"
                        :tags="recommendedUsagesTags"
                        v-if="recommendedUsagesTags.length > 0"
                    />
                    <tag-list
                        class="application-tags"
                        :title="$t('recommanded_for_these_applications')"
                        :tags="recommendedApplicationTags"
                        tag-style="grey"
                        v-if="recommendedApplicationTags.length > 0"
                    />
                </div>
            </div>
            <sheet-block-associated-solutions />
        </div>
    </main>
</template>

<script>
import { mapState } from 'vuex'

import attributeService from "@/services/akeneo/attribute";
import productModelService from "@/services/akeneo/productModel";

import SheetBlockOverviewPicture from "@/components/SheetBlock/SheetBlockOverviewPicture";
import TitledParagraphList from "@/components/TitledParagraph/TitledParagraphList";
import SheetBlockKeyFeatures from "@/components/SheetBlock/SheetBlockKeyFeatures";
import TagList from "@/components/Tag/TagList";
import SheetBlockAssociatedSolutions from "@/components/SheetBlock/SheetBlockAssociatedSolutions";
import productService from '@/services/serli/product'
import experienceService from "@/services/salesbox/experience";
import {toggleBodyClass} from "@/common/helpers";

export default {
    name: 'MachineSummaryView',
    components: {
        SheetBlockOverviewPicture,
        TitledParagraphList,
        SheetBlockKeyFeatures,
        TagList,
        SheetBlockAssociatedSolutions,
    },
    data() {
        return {
            recommendedBusinessesTags: [],
            recommendedUsagesTags: [],
            recommendedApplicationTags: [],
            machineApplications: [],
            paragraphsMainTitle: this.$t('range_highligths'),
            isAR: false,
            is360Int: false,
            is360Ext: false,
            experienceData: undefined
        }
    },
    computed: {
        ...mapState({
            productDatas: state => state.sheet.productDatas,
            applications: state=>state.settings.applications,
            locale: state=>state.settings.locale,
            machineExperiences: state=>state.settings.machine_experiences,
        }),
      mainImage() {
        if(this.productDatas.values.main_visual) return this.productDatas.values.main_visual.large ; else return require("@/assets/img/no_image_available.jpg");
      },
        paragraphs(){
            let paragraphs = [];
            for(let i=1; i<=5; i++)
                if(this.productDatas.values['title_key_point_'+i] && this.productDatas.values['key_point_description_'+i])
                    paragraphs.push({
                        title: this.productDatas.values['title_key_point_'+i].label,
                        text: this.productDatas.values['key_point_description_'+i].label,
                        benefit: this.productDatas.values['customer_benefits_'+i] ? this.productDatas.values['customer_benefits_'+i].label : this.productDatas.values['benefits_'+i] ? this.productDatas.values['benefits_'+i].label : ''
                    })
            return paragraphs;
        },
        isFromARMachines() {
          const specificMT=['MT_730_H','MT_930_H','MT_930_HA'];
          let ARMachinesCodes = [];
          if (!this.machineExperiences) return false;
          //ici boucle sur objet pour trouver toutes les familles
          this.machineExperiences.forEach((x) => {
            ARMachinesCodes.push(x.range)
          })
          const result=ARMachinesCodes.includes(this.productDatas.categories[0]);
          if(this.productDatas.family.code === "MT" && !specificMT.includes(this.productDatas.identifier)) return false; else return result;
        },
        familyForAR() {

          if(this.isFromARMachines) {
            if (this.productDatas.family.code === "MT") {
              return 'mt_730_930';
            } else {
              return 'mrt_vision';
            }
          } else {
            return '';
          }
        }
    },
    async mounted(){
        this.startLoading();
        this.getExperienceDetails().then(() => {
          this.stopLoading();
        });
        this.fetchApplications()

        // toggleBodyClass('removeClass', 'no-scroll');
    },
    methods: {
        fetchApplications(){
          this.stopLoading()
          this.productDatas.attachments_products.forEach((attachment) => {
            productService.show(attachment.code, {
              locale: this.localeKebabFormat,
              unit: this.unitType,
              country: this.country
            }).then((response) => {
              if (response.data.code === 200) {
                this.machineApplications=this.machineApplications.concat(response.data.data.applications)
                this.machineApplications=[...new Set(this.machineApplications)]

              }
            }).finally(()=> {this.setRecommendedApplicationsTags()})
          })
        },
        setRecommendedUsagesTags(){
            if(this.productDatas.values.secondary_markets !== undefined){
                let tags = [];
                this.productDatas.values.secondary_markets.forEach(market=> {
                    tags.push(market.label);
                })
              this.recommendedUsagesTags = tags;
            }
        },

        setRecommendedApplicationsTags(){
          this.recommendedApplicationTags=[];
          if(this.productDatas.applications){
            this.productDatas.applications.forEach((application)=>{
              var app=this.applications.find(x => x.code == application)
              this.recommendedApplicationTags.push(app)
            })
          }
          if(this.machineApplications){
            this.machineApplications.forEach((application)=>{

              var app=this.applications.find(x => x.code == application)

              this.recommendedApplicationTags.push(app)

            })
          }
          var tempApplications=[]
          this.recommendedApplicationTags.forEach(application=>{
            application.route={name: 'machine-sheet-accessories', params: {id: this.productDatas.identifier, name: this.slugifyName(this.productDatas)}, query: {application: application.code} }
            tempApplications.push(application)
          })
          this.recommendedApplicationTags=tempApplications
        },
        async getExperienceDetails() {
         if(this.productDatas.experience) return this.productDatas.experience
          else return false
        }

    }
}
</script>

<style lang="scss">
    #machine-sheet-summary {
        padding-bottom: 40px;

        .titled-paragraphs-container {
            position: relative;
            padding-top: 40px;
            padding-right: 90px;
            padding-bottom: 30px;

            @media #{$mq_phone} {
                padding: 20px 30px;
            }
        }

        .jobs-tags {
            margin-bottom: 40px;
        }
    }
</style>
